module.exports = __webpack_public_path__ + "img/pic_5.61503822.png";